import { Reveal } from "../components/Reveal";
import { GoldenArc } from "../components/GoldenArc";

export const Positioning = () => (
    <section
        data-testid="positioning-section"
        className="relative overflow-hidden bg-graphite-dark py-28 sm:py-36"
    >
        <div className="pointer-events-none absolute inset-x-0 top-8">
            <GoldenArc className="h-28 w-full opacity-40" />
        </div>
        <div className="pointer-events-none absolute -bottom-32 left-1/2 h-[420px] w-[720px] -translate-x-1/2 rounded-full bg-gold/[0.07] blur-[130px]" />

        <Reveal className="relative mx-auto max-w-4xl px-5 text-center sm:px-8">
            <p className="mb-10 font-mono text-[11px] uppercase tracking-[0.32em] text-gold-light">
                Posicionamento
            </p>
            <blockquote className="font-serif text-3xl leading-snug text-cream sm:text-4xl lg:text-5xl">
                “Alta especialização. Máxima discrição.{" "}
                <span className="italic text-gold-light">
                    Segurança para decisões que envolvem patrimônio e negócios.
                </span>
                ”
            </blockquote>
            <p className="mt-10 font-mono text-[11px] uppercase leading-relaxed tracking-[0.28em] text-graphite-mute">
                CAJUSP — Câmara de Juízo Arbitral
                <br className="sm:hidden" /> e Mediação Empresarial de São Paulo
            </p>
        </Reveal>
    </section>
);
